<template>
  <div :class="classList">
    <p>
      <h5>{{ this.task.activites_ama.description_fr }}</h5>
      <div>{{this.task.commentaire}}</div>
    </p>
    <h3 class="warning">{{ this.task.patient.nom }} {{ this.task.patient.prenom }}</h3>
    <h6 class="warning"> Modifier par: {{ this.task.patient.nom }} {{ /*this.task.updated_by.prenom*/ }}</h6>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default{
  // Board -> Section -> sectionIndex / Section -> task, taskIndex
  props: {
    sectionIndex: {
      type: Number,
      required: true
    },
    taskIndex: {
      type: Number,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
  },
  data(){
    return {
      newContent: "",
      isEditing: false,
    }
  },
  computed: {
    classList(){
      const classList = ['task']
      return classList;
    },
  },
  methods:{
    ...mapActions(['deleteTask', 'updateTask']),
  },
}
</script>
